var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLatencyFair = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 8.94737,
    height: 2,
    fill: "#FFAA44"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 8.94737,
    height: 2,
    fill: "#FFAA44"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 8.94737,
    height: 2,
    fill: "#FFAA44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 8.94737,
    height: 2,
    fill: "#797775"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 8.94737,
    height: 2,
    fill: "#797775"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLatencyFair);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Latency_fair.25fefac928d738808bbf828a4b238903.svg";